import { useState } from 'react';
import ChangeLog from '../components/ChangeLog';
import type { InitiatorKind, ResourceKind, ChangeAction } from '../api';

export default function Changes() {
  const [resourceType, setResourceType] = useState<ResourceKind | ''>('');
  const [initiatorKind, setInitiatorKind] = useState<InitiatorKind | ''>('');
  const [action, setAction] = useState<ChangeAction | ''>('');

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-end gap-3">
        <Select label="Resource" value={resourceType} onChange={setResourceType as any}
          options={['', 'household', 'person', 'calling', 'interaction']} />
        <Select label="Initiator" value={initiatorKind} onChange={setInitiatorKind as any}
          options={['', 'lcr_sync', 'user_ui', 'user_api', 'user_mcp', 'system']} />
        <Select label="Action" value={action} onChange={setAction as any}
          options={['', 'created', 'updated', 'removed', 'restored']} />
      </div>
      <ChangeLog
        resourceType={resourceType || undefined}
        initiatorKind={initiatorKind || undefined}
        action={action || undefined}
        showResource
        limit={200}
      />
    </div>
  );
}

function Select<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: T;
  options: T[];
  onChange: (v: T) => void;
}) {
  return (
    <label className="flex flex-col gap-0.5 text-xs text-slate-600 dark:text-slate-400">
      <span>{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        className="rounded border border-slate-300 dark:border-slate-600 px-2 py-1 text-sm"
      >
        {options.map((o) => (
          <option key={o} value={o}>{o || '(any)'}</option>
        ))}
      </select>
    </label>
  );
}
